
export enum InventoryManagementMethod {
    None = "None",
    FEFO = "FEFO", // First Expired First Out
    FIFO = "FIFO", // First In Firs tOut
    LIFO = "LIFO"  // Last In First Out
}
